module.exports = __webpack_public_path__ + "static/media/bus_ticket_2.6bba839d.svg";